<vex-page-layout mode="card">
    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.px-gutter]="true" class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">Configuración</h1>
                <vex-breadcrumbs [crumbs]="crumbs"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content>
        <div class="card">
            <mat-tab-group>
                <mat-tab label="Opciones">
                    <div class="p-6">
                        <div class="grid grid-flow-col gap-3">
                            <div class="px-6 py-4 flex flex-col">
                                <form (ngSubmit)="updateStatus()" [formGroup]="form2">
                                    <div class="px-6 py-4 flex flex-col">
                                        <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="4px">
                                            <mat-slide-toggle color="primary" labelPosition="before"
                                                formControlName="notificacion" [disabled]="false">Notificaciones
                                            </mat-slide-toggle>
                                        </div>
                                        <div class="flex items-center justify-end gap-2">
                                            <!--<button mat-button type="button">{{appSettings.DIALOG_BUTTON_CANCEL}}</button>-->
                                            <button color="primary" mat-raised-button type="submit" [disabled]="form1.invalid">{{appSettings.DIALOG_BUTTON_SAVE_POSITIVE}}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Plantillas">
                    <div class="p-6">
                        <div class="grid grid-flow-col gap-3">
                            <div class="col-span-1">
                                <div class="px-6 py-4 border-b flex items-center">
                                    <h2 class="title m-0 flex-auto">Configuración de plantilla</h2>                                    
                                </div>
                                <div class="px-6 py-4 flex flex-col">
                                    <form (ngSubmit)="save()" [formGroup]="form2">
                                        <div class="px-6 py-4 flex flex-col">
                                            <mat-accordion multi>
                                                <mat-expansion-panel [expanded]="true">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title>ENTRADAS PARA WHATSAPP</mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Mensaje inicial:</mat-label>
                                                            <input matInput formControlName="inicial">
                                                        </mat-form-field>
                                                    </div>
                                                </mat-expansion-panel>
                                                <mat-expansion-panel [expanded]="true">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title>ENTRADAS PARA EMAIL</mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Asunto:</mat-label>
                                                            <input matInput formControlName="asunto">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Saludo:</mat-label>
                                                            <input matInput formControlName="saludo">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Cuerpo:</mat-label>
                                                            <textarea matInput formControlName="cuerpo" rows="3"></textarea>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Despedida:</mat-label>
                                                            <input matInput formControlName="despedida">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Firma:</mat-label>
                                                            <textarea matInput formControlName="firma" rows="3"></textarea>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex items-center justify-end gap-2">
                                                        <!--<button mat-button type="reset">{{appSettings.DIALOG_BUTTON_CANCEL}}</button>-->
                                                        <button color="primary" mat-raised-button type="submit" [disabled]="form2.invalid">{{appSettings.DIALOG_BUTTON_SAVE_POSITIVE}}</button>
                                                    </div>
                                                </mat-expansion-panel>
                                            </mat-accordion>
                                        </div>  
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </vex-page-layout-content>
</vex-page-layout>